const RadioInput = ({ options, value, onChange, disabled }) => {
  return (
    <div className="flex flex-wrap gap-4">
      {options.map(option => {
        const isSelected = value === option;

        return (
          <label
            key={option}
            className={`
              flex items-center gap-3 px-4 h-[33px] border rounded-[6px] cursor-pointer
              text-[16px] font-[500] text-[#494E58]
              transition-all
              ${
                isSelected
                  ? "border-[#494E58]"
                  : "border-[#E9EAEB]"
              }
              ${disabled ? "cursor-not-allowed" : "hover:border-[#494E58]"}
            `}
          >
            <input
              type="radio"
              disabled={disabled}
              checked={isSelected}
              onChange={() => onChange(option)}
              className="accent-[#494E58]"
            />

            <span className="whitespace-nowrap">
              {option}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioInput;
